import { LegalPage } from "../legal/legal-page"
import { termsContent } from "./terms-content"

/**
 * Public, unauthenticated Terms & Conditions page (route: /terms).
 * Renders the bilingual legal document with an English / Arabic toggle.
 */
export function TermsPage() {
  return (
    <LegalPage
      document={termsContent}
      metaDescription="Terms & Conditions for the Taqat AI Employee Store platform and services."
    />
  )
}
